import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Column, DescriptiveText, LoadingSpinner, Row, TextInput} from '../../../shared';
import debug from 'debug';
import {formatter} from '../../../shared/utils/utils';
import useSWR from 'swr';
import history from '../../../history';
import {_getDefaultContainerID} from '../../reducers/defaultContainerID';
import axiosInstance from '../../../shared/utils/axios';
import {isEntitled} from '../../../shared/reducers/user';
import {_openModal} from '../../../shared/reducers/modals';
import useQueryObject from '../../../shared/utils/useQueryObject';
import HouseholdActivationButton from '../components/HouseholdActivationButton';

const log = debug('circleblack:advisor:household:summary');

const HouseholdInfoSummary = ({householdID, defaultContainerID, getDefaultContainerID, session, openModal}) => {
  const {data: household} = useSWR(
    defaultContainerID && `/containers/${defaultContainerID}/households?id=${householdID}&limit=1`,
    url => axiosInstance.get(url).then(res => res.data[0])
  );
  const [context] = useQueryObject('context');

  React.useEffect(() => {getDefaultContainerID();}, []);
  log('household', household);

  if (!household) {
    return <LoadingSpinner/>;
  }

  return <Column height={'150px'} layout={{grow: 1}}>
    {(household.isHouseholdAdvisor
      && !household.totalLogins)
      ? <HouseholdActivationButton
        size="md"
        width="150px"
        importance={household.activatedAt ? 'secondary' : 'primary'}
        household={{
          ...household,
          id: householdID,
        }}
      />
      : null
    }
    <Row>
      <TextInput readOnly={true}
                 placeholder={'Status'}
                 type={'text'}
                 width={'100px'}
                 layout={{grow: 1}}
                 title={'Status'}
                 dataPoint={{name: 'typeName', value: household.activatedAt ? 'Active' : 'Inactive'}}/>
      {!!household.activatedAt && <TextInput readOnly={true}
                                             title={'Total Logins'}
                                             width={'100px'}
                                             layout={{grow: 1}}
                                             placeholder={'Count of Logins'}
                                             type={'text'}
                                             dataPoint={{name: 'activatedAt', value: household.totalLogins}}/>}
      {!!household.activatedAt && <>
        <TextInput readOnly={true}
                   placeholder={'Activation Timestamp'}
                   type={'text'}
                   width={'100px'}
                   layout={{grow: 1}}
                   title={'Activated'}
                   dataPoint={{name: 'activatedAt', value: formatter('datetime')(household.activatedAt)}}/>

        {household.activationEmailSentFailure && <DescriptiveText>Email Not Delivered</DescriptiveText>}
      </>}
    </Row>
    <Row>
      {!!session.profile.redtail
        ? <Button importance={'secondary'}
                  size={'md'}
                  width={'130px'}
                  label={'View on Redtail'}
                  action={() => history.push(`/engage/redtail?householdID=${householdID}`)}/> : null}
      {(!!session.profile.sfsID && isEntitled([{group: 'partners', feature: 'sfs', access: 'r'}]))
        ? <Button importance={'secondary'}
                  size={'md'}
                  label={'View on Salesforce'}
                  action={() => history.push(`/engage/sfs/sso?householdID=${householdID}`)}/> : null}
      {!!session.profile.wealthbox
        ? <Button importance={'secondary'}
                  size={'md'}
                  width={'130px'}
                  label={'View on Wealthbox'}
                  action={() => history.push(`/engage/wealthbox?householdID=${householdID}`)}/> : null}
      {isEntitled([{group: 'reports', feature: 'core', access: 'c'}])
        ? <Button importance={'secondary'}
                  size={'md'}
                  width={'130px'}
                  label={'Generate Report'}
                  action={() => openModal({type: 'ContextReportModal', context})}/> : null}
      {isEntitled([{group: 'advisor', feature: 'view_as_investor', access: 'r'}])
        ? <Button importance={'secondary'}
                  size={'md'}
                  width={'fit-content'}
                  label={'Investor Experience'}
                  action={() => history.push(`/investor/${household.id}`)}/> : null}
    </Row>
  </Column>;
};

const mapStateToProps = state => ({
  session: state.session,
  defaultContainerID: state.defaultContainerID,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
  getDefaultContainerID: () => dispatch(_getDefaultContainerID()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HouseholdInfoSummary);

HouseholdInfoSummary.propTypes = {
  householdID: PropTypes.number.isRequired,
  advisorID: PropTypes.number,
  session: PropTypes.object,
  openModal: PropTypes.func.isRequired,
  defaultContainerID: PropTypes.number,
  getDefaultContainerID: PropTypes.func,
};
